/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Feature_Tested_DescriptionInputs */

const en_marketing_feature_tested_description = /** @type {(inputs: Marketing_Feature_Tested_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playwright end-to-end coverage, Vitest, CI bundle budgets, and strict TypeScript.`)
};

const es_marketing_feature_tested_description = /** @type {(inputs: Marketing_Feature_Tested_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cobertura de extremo a extremo con Playwright, Vitest, presupuestos de tamaño en CI y TypeScript estricto.`)
};

const fr_marketing_feature_tested_description = /** @type {(inputs: Marketing_Feature_Tested_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couverture de bout en bout avec Playwright, Vitest, budgets de bundle en CI et TypeScript strict.`)
};

/**
* | output |
* | --- |
* | "Playwright end-to-end coverage, Vitest, CI bundle budgets, and strict TypeScript." |
*
* @param {Marketing_Feature_Tested_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_feature_tested_description = /** @type {((inputs?: Marketing_Feature_Tested_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Feature_Tested_DescriptionInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_feature_tested_description(inputs)
	if (locale === "es") return es_marketing_feature_tested_description(inputs)
	return fr_marketing_feature_tested_description(inputs)
});